import React from "react";
import * as yup from "yup";
import { Formik, Form } from "formik";
import {
    customStringify,
    error_alert,
    stringNotEmpty,
    success_alert,
} from "../../utils";
import TextField from "../../components/FormikFields/TextField";
import { BiLoaderAlt } from "react-icons/bi";
import { Link, useNavigate, useParams } from "react-router-dom";
import { network_tl, password_number_tl, password_short_tl, password_smallcase_tl, password_special_tl, password_uppercase_tl, passwords_match_tl, required_tl } from "../../translations";
import { FormattedMessage, useIntl } from "react-intl";
import useApi from "../../hooks/useApi";

const FormContainer = ({ reset }) => {
    const intl = useIntl();
    const navigate = useNavigate();
    const { Axios } = useApi();
    const { id } = useParams();

    const initialValues = {
        password: "",
        confirmPassword: ""
    };

    yup.addMethod(yup.string, "stringNotEmpty", stringNotEmpty);
    const validationSchema = yup.object({
        password: yup.string()
            .required(required_tl(intl))
            .min(8, password_short_tl(intl))
            .matches(/[a-z]/, password_smallcase_tl(intl))
            .matches(/[A-Z]/, password_uppercase_tl(intl))
            .matches(/\d/, password_number_tl(intl))
            .matches(/[!@#$%^&*]/, password_special_tl(intl)),

        confirmPassword:
            yup
                .string()
                .required(required_tl(intl))
                .oneOf([yup.ref('password'), null], passwords_match_tl(intl))
    });

    const handleSubmit = async (values, formikBag) => {
        try {
            const result = await Axios.put(`api/user/password/${id}/${reset ? "reset" : "activate"}`, {
                password: values.password
            });
            success_alert(result.data.description);
            navigate("/")
        } catch (e) {
            if (e.response) {
                error_alert(customStringify(e.response.data.description))
            } else {
                error_alert(network_tl(intl));
            }
        }
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {(form) => (
                <Form className="mt-5">
                    <>
                        <p className="font-medium mb-5 text-gray-700">
                            <FormattedMessage id="set_new_password_with_instructions" defaultMessage="Please set your new password by following the instructions below." />
                        </p>
                        <ul className="list-disc mb-5 pl-5">
                            <li className="text-gray-700 font-medium text-sm">
                                {
                                    password_short_tl(intl)

                                }
                            </li>
                            <li className="text-gray-700 font-medium text-sm">
                                {
                                    password_smallcase_tl(intl)
                                }
                            </li>
                            <li className="text-gray-700 font-medium text-sm">
                                {
                                    password_uppercase_tl(intl)

                                }
                            </li>
                            <li className="text-gray-700 font-medium text-sm">
                                {
                                    password_number_tl(intl)

                                }
                            </li>
                            <li className="text-gray-700 font-medium text-sm">
                                {
                                    password_special_tl(intl)
                                }
                            </li>
                        </ul>

                        <div className="space-y-5">
                            <div>
                                <TextField
                                    type="password"
                                    field="password"
                                    label_text={
                                        <FormattedMessage
                                            id="password"
                                            defaultMessage="Password"
                                        />
                                    }
                                    form={form}
                                />
                            </div>
                            <div>
                                <TextField
                                    type="password"
                                    field="confirmPassword"
                                    label_text={
                                        <FormattedMessage
                                            id="confirm_password"
                                            defaultMessage="Confirm Password"
                                        />
                                    }
                                    form={form}
                                />
                            </div>
                            <div className="flex items-center pt-3 pb-3">
                                <button
                                    type="submit"
                                    disabled={form.isSubmitting}
                                    className="block w-full btn btn-primary"
                                >
                                    <p>
                                        {form.isSubmitting ? (
                                            <BiLoaderAlt className="animate-spin text-white text-3xl mx-auto" />
                                        ) : (
                                            intl.formatMessage({ id: "submit", defaultMessage: "Submit" })
                                        )}
                                    </p>
                                </button>
                            </div>

                            <hr className="" />
                            <p className="text-xs md:text-sm text-center">
                                <FormattedMessage
                                    id="back_login"
                                    defaultMessage={
                                        "Back to {link}"
                                    }
                                    values={{
                                        link: (
                                            <Link
                                                className="text-primary underline font-medium"
                                                to="/"
                                            >
                                                <FormattedMessage id="login" defaultMessage={"Login"} />
                                            </Link>
                                        ),
                                    }}
                                />
                            </p>
                        </div>
                    </>
                </Form>
            )}
        </Formik>
    );
};

export default FormContainer;
